import { PermissionType } from "../types";
import { type AccountColumnOptions } from "./types";
import { SortingDirection } from "enums";

export const PermissionTypeToString: { [key in PermissionType]: string } = {
  [PermissionType.None]: "None",
  [PermissionType.Limited]: "Limited",
  [PermissionType.Full]: "Full",
  [PermissionType.View]: "View Only",
};

export const defaultSorting = Object.freeze({
  columnName: "added",
  direction: SortingDirection.Descending,
});

export const columnOptions: AccountColumnOptions[] = [
  {
    name: "Name",
    width: 7,
    isSortable: true,
    propName: "name",
    className: "linked-account-name-header",
  },
  {
    name: "Account type",
    width: 5,
    isSortable: true,
    propName: "accountTypeName",
  },
  {
    name: "Labels",
    width: 5,
    isSortable: true,
    propName: "labels",
  },
  {
    name: "Permissions",
    width: 5,
    isSortable: true,
    propName: "permissionType",
  },
  {
    name: "Added",
    width: 3,
    isSortable: true,
    propName: "added",
  },
  {
    name: "",
    width: 1,
    className: "align-right",
    isSortable: false,
    propName: "",
  },
];
